/**
 * Phe Quick Add - Global bottom modal with carousel and variant selection
 */

(function() {
  'use strict';

  window.PheQuickAdd = {
    panel: null,
    backdrop: null,
    form: null,
    swiper: null,
    currentProduct: null,
    currentVariant: null,
    selectedOptions: {},
    initialized: false,
    wasProductPage: false, // Track if body already had template-product class

    init: function() {
      if (this.initialized) return;
      

      // Create backdrop
      this.backdrop = document.createElement('div');
      this.backdrop.className = 'phe-quick-add-backdrop';
      this.backdrop.addEventListener('click', this.close.bind(this));

      // Create panel
      this.panel = document.createElement('div');
      this.panel.className = 'phe-quick-add-panel';
      this.panel.setAttribute('data-page-type', 'product');
      this.panel.setAttribute('data-template', 'product');
      this.panel.setAttribute('role', 'dialog');
      this.panel.setAttribute('aria-label', 'Quick Add Product');
      this.panel.setAttribute('aria-modal', 'true');
      this.panel.innerHTML = `
        <div class="phe-quick-add__carousel">
          <button type="button" class="phe-quick-add-panel__close" aria-label="Close"></button>
          <div class="swiper phe-quick-add-swiper">
            <div class="swiper-wrapper" data-carousel-container></div>
            <div class="swiper-button-prev"></div>
            <div class="swiper-button-next"></div>
            <div class="swiper-pagination"></div>
          </div>
        </div>
        <div class="phe-quick-add__content">
          <a href="#" class="phe-quick-add__title" data-product-title></a>
          <div class="phe-quick-add__price" data-product-price></div>
          
          <product-form class="product-form" data-hide-errors="false" data-section-id="phe-quick-add">
            <div class="product-form__error-message-wrapper" role="alert" hidden>
              <span class="svg-wrapper">
                <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-error" viewBox="0 0 13 13">
                  <circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"/>
                  <circle cx="6.5" cy="6.5" r="4.5" fill="white" stroke="white" stroke-width="1"/>
                  <path d="M5.87413 3.52832L5.87413 7.37399L7.12587 7.37399L7.12587 3.52832L5.87413 3.52832ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="currentColor"/>
                </svg>
              </span>
              <span class="product-form__error-message"></span>
            </div>
            
            <form method="post" action="/cart/add" id="phe-quick-add-form" class="form" novalidate="novalidate" data-type="add-to-cart-form" data-product-id="" data-product-handle="">
              <input type="hidden" name="product-id" value>
              <input type="hidden" name="id" data-variant-id class="product-variant-id">
              
              <div data-sibling-swatches-container></div>
              
              <div data-options-container></div>
              
              <div class="product-form__buttons">
                <button
                  id="PheQuickAddSubmitButton"
                  type="submit"
                  name="add"
                  class="product-form__submit button button--full-width button--add-to-bag button--secondary"
                  disabled
                >
                  <span>Add to Bag</span>
                  <div class="loading__spinner hidden">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                  </div>
                </button>
              </div>
            </form>
          </product-form>
          
          <a href="#" class="phe-view-details-link" data-product-link>View Product Details</a>
        </div>
      `;

      // Append to body
      document.body.appendChild(this.backdrop);
      document.body.appendChild(this.panel);

      // Get form references
      this.productForm = this.panel.querySelector('product-form');
      this.form = this.panel.querySelector('form');

                  // Override product-form's toggleSubmitButton to always use "Add to Bag"
      if (this.productForm) {
        // Override the toggleSubmitButton method
        const originalToggleSubmitButton = this.productForm.toggleSubmitButton?.bind(this.productForm);
        if (originalToggleSubmitButton) {
          this.productForm.toggleSubmitButton = function(disable = true, text) {
            if (disable) {
              this.submitButton.setAttribute('disabled', 'disabled');
              if (text) this.submitButtonText.textContent = text;
            } else {
              this.submitButton.removeAttribute('disabled');
              // Always use "Add to bag" instead of "Add to Cart"
              this.submitButtonText.textContent = 'Add to bag';
            }
          };
        }
        
        // Also add a MutationObserver to watch for any text changes and force it back
        const submitBtn = this.form.querySelector('.product-form__submit');
        const buttonSpan = submitBtn?.querySelector('span');
        if (buttonSpan) {
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'childList' || mutation.type === 'characterData') {
                const currentText = buttonSpan.textContent.trim();
                // If text changes to "Add to Cart" or the variantStrings value, change it back
                if (currentText === 'Add to Cart' || 
                    currentText === window.variantStrings?.addToCart ||
                    (currentText !== 'Add to bag' && currentText !== 'Sold Out' && currentText !== 'Adding...')) {
                  buttonSpan.textContent = 'Add to bag';
                }
              }
            });
          });
          
          observer.observe(buttonSpan, { 
            childList: true, 
            characterData: true, 
            subtree: true 
          });
          
          // Store observer so we can disconnect it later if needed
          this.buttonTextObserver = observer;
        }
      }

      // Attach event listeners
      this.panel.querySelector('.phe-quick-add-panel__close').addEventListener('click', this.close.bind(this));

      this.initialized = true;
    },

    open: function(productData) {
      this.init();
      
      // Ensure panel is fully closed before opening a new one
      this.backdrop.classList.remove('active');
      this.panel.classList.remove('active');
      
      // Set product data immediately
      this.currentProduct = productData;
      this.selectedOptions = {};
      
      // Initialize first options
      if (productData.options && productData.options.length > 0) {
        productData.options.forEach(function(option) {
          if (option.values && option.values.length > 0) {
            this.selectedOptions[option.name] = option.values[0];
          }
        }.bind(this));
      }
      
      // Render immediately
      this.render();
      this.updateVariant();

      // Show panel and backdrop with minimal delay for CSS transitions
      requestAnimationFrame(function() {
        this.backdrop.classList.add('active');
        this.panel.classList.add('active');
        
        // Add product page classes to body for universal third-party app detection
        // Check if we're not already on a product page to avoid conflicts
        if (!document.body.classList.contains('template-product')) {
          document.body.classList.add('template-product');
          document.body.setAttribute('data-template', 'product');
          this.wasProductPage = false; // Track if we added it
        } else {
          this.wasProductPage = true; // Already was a product page
        }
        
        // Add quick-add-specific classes
        document.body.classList.add('quick-add-active');
        this.panel.classList.add('template-product-context');
        
        // Add product data attributes for third-party app detection
        if (this.currentProduct) {
          this.panel.setAttribute('data-product-id', this.currentProduct.id);
          this.panel.setAttribute('data-product-handle', this.currentProduct.url.replace('/products/', '').replace(/\/$/, ''));
          this.panel.setAttribute('data-product-title', this.currentProduct.title);

          this.panel.querySelector('[name="product-id"]').value = this.currentProduct.id;
        }
        
        // Trigger third-party app initialization (Klaviyo, etc.)
        this.initializeThirdPartyApps();
        
        // Ensure product-form custom element is properly initialized
        // The product-form will handle form submission and cart drawer integration
      }.bind(this));
    },

    render: function() {
      const product = this.currentProduct;

      // Update title and price
      const titleLink = this.panel.querySelector('[data-product-title]');
      titleLink.textContent = product.title;
      titleLink.href = product.url;
      this.panel.querySelector('[data-product-price]').textContent = product.price;
      this.panel.querySelector('[data-product-link]').href = product.url;

      // Update product data attributes for third-party apps
      const productHandle = product.url.replace('/products/', '').replace(/\/$/, '');
      this.panel.setAttribute('data-product-id', product.id);
      this.panel.setAttribute('data-product-handle', productHandle);
      this.panel.setAttribute('data-product-title', product.title);
      
      // Also update form attributes for third-party app detection
      if (this.form) {
        this.form.setAttribute('data-product-id', product.id);
        this.form.setAttribute('data-product-handle', productHandle);
      }

      // Ensure button is visible
      const submitBtn = this.form.querySelector('.product-form__submit');
      if (submitBtn) {
        submitBtn.removeAttribute('hidden');
        submitBtn.style.display = 'block';
        submitBtn.style.visibility = 'visible';
      }

      // Render carousel
      this.renderCarousel(product.images);

      // Render sibling swatches
      this.renderSiblingSwatches(product);

      // Render options
      this.renderOptions(product.options);
    },

    renderCarousel: function(images) {
      const container = this.panel.querySelector('[data-carousel-container]');
      if (!container) return;
      
      container.innerHTML = '';

      if (!images || images.length === 0) {
        images = [{url: '', alt: 'Product image'}];
      }

      images.forEach(function(media) {
  const slide = document.createElement('div');
  slide.className = 'swiper-slide';
  
  if (media.type === 'video') {
    slide.innerHTML = `<video src="${media.url}" autoplay loop muted playsinline style="width: 100%; height: 100%; object-fit: cover;"></video>`;
  } else {
    slide.innerHTML = `<img src="${media.url}" alt="${media.alt}">`;
  }
  
  container.appendChild(slide);
});

      // Ensure any existing swiper is fully destroyed before creating a new one
      if (this.swiper) {
        try {
          this.swiper.destroy(true, true);
        } catch (e) {
          console.warn('Swiper destroy error in renderCarousel:', e);
        }
        this.swiper = null;
      }

      // Wait a tick to ensure DOM is ready, then initialize Swiper
      setTimeout(function() {
        if (!this.currentProduct) return; // Don't initialize if panel was closed
        
        try {
          this.swiper = new Swiper('.phe-quick-add-swiper', {
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: true,
            mousewheel: {
              forceToAxis: true,
            },
          });
        } catch (e) {
          console.error('Swiper initialization error:', e);
        }
      }.bind(this), 50);
    },

    renderOptions: function(options) {
      const container = this.panel.querySelector('[data-options-container]');
      container.innerHTML = '';

      if (!options || options.length === 0) return;

      // Simple inline layout like phe
      options.forEach(function(option, index) {
        // Skip default "Title" option for products with no variants
        if (option.name === 'Title' && option.values.length === 1 && option.values[0] === 'Default Title') {
          return;
        }
        
        const isColor = option.name.toLowerCase().includes('color') || option.name.toLowerCase().includes('colour');
        
                if (isColor) {
          // Skip color options (same as product page hide_variant_picker setting)
          return;
        }
        
        // Render simple size selector with underline
        const sizeDiv = document.createElement('div');
        sizeDiv.className = 'phe-size-selector';
        
        const buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'phe-size-buttons';
        
        option.values.forEach(function(value) {
          const button = this.createSizeButton(value, option.name);
          buttonsContainer.appendChild(button);
        }.bind(this));
        
        sizeDiv.appendChild(buttonsContainer);
        container.appendChild(sizeDiv);
      }.bind(this));
    },

    renderSiblingSwatches: function(product) {
      const container = this.panel.querySelector('[data-sibling-swatches-container]');
      container.innerHTML = '';

      const siblings = product?.metafields?.custom?.siblings;
      if (!siblings || !siblings.length) return;

      const wrap = document.createElement('div');
      wrap.className = 'product-item-modal__swatches';

      const ul = document.createElement('ul');
      ul.className = 'product-swatches product-swatches--center list-none';

      const isLightHex = (hex) => {
        if (!hex || typeof hex !== 'string') return false;
        const h = hex.replace('#','');
        if (h.length !== 6) return false;
        const r = parseInt(h.slice(0,2), 16);
        const g = parseInt(h.slice(2,4), 16);
        const b = parseInt(h.slice(4,6), 16);
        const lum = (0.2126*r + 0.7152*g + 0.0722*b) / 255;
        return lum > 0.85;
      };

      siblings.forEach(function(s) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'product-swatch';
        // Normalize id types to ensure active state persists after re-render
        var isActive = String(s.id) === String(product.id);
        a.setAttribute('data-swatch-active', isActive ? 'true' : 'false');
        a.href = s.url;
        a.title = s.title;

        const cImg = s?.metafields?.custom?.swatch_image || null;
        const c1 = s?.metafields?.custom?.swatch_color || null;
        const c2 = s?.metafields?.custom?.swatch_color_2 || null;
        const style = cImg
          ? `background-image: url(${cImg});`
          : (c2
              ? ((s?.metafields?.custom?.swatch_style || '').toLowerCase() === 'diagonal'
                  ? `background-image: linear-gradient(45deg, ${c1} 0 50%, ${c2} 50% 100%);`
                  : `background-image: linear-gradient(90deg, ${c1} 0 50%, ${c2} 50% 100%);`)
              : (c1 ? `--background-color: ${c1};` : ''));
        if (style) a.setAttribute('style', style);
        if (!c2 && isLightHex(c1)) a.classList.add('product-swatch--light');

        const sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = s?.metafields?.custom?.color_name || s.title;
        a.appendChild(sr);

        a.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          ul.querySelectorAll('.product-swatch').forEach(el => el.setAttribute('data-swatch-active', 'false'));
          this.setAttribute('data-swatch-active', 'true');
          const href = this.getAttribute('href');
          if (href && window.PheQuickAdd && typeof window.PheQuickAdd.loadProductIntoQuickAdd === 'function') {
            window.PheQuickAdd.loadProductIntoQuickAdd(href);
          }
        });

        li.appendChild(a);
        ul.appendChild(li);
      }.bind(this));

      wrap.appendChild(ul);
      container.appendChild(wrap);
    },

    createColorSwatch: function(value, optionName) {
      const swatch = document.createElement('button');
      swatch.type = 'button';
      swatch.className = 'phe-color-swatch';
      if (this.selectedOptions[optionName] === value) {
        swatch.classList.add('active');
      }
      
      // Color mapping
      const colorMap = {
        'white': '#ffffff',
        'black': '#000000',
        'gray': '#808080',
        'grey': '#808080',
        'red': '#ff0000',
        'blue': '#0000ff',
        'green': '#008000',
        'pink': '#ffc0cb',
        'beige': '#f5f5dc',
        'brown': '#8b4513',
        'navy': '#000080',
        'purple': '#800080'
      };
      
      const colorValue = colorMap[value.toLowerCase()] || value.toLowerCase();
      swatch.style.backgroundColor = colorValue;
      if (value.toLowerCase() === 'white') {
        swatch.style.borderColor = '#ddd';
      }
      
      swatch.addEventListener('click', function() {
        this.selectOption(optionName, value);
      }.bind(this));
      
      return swatch;
    },

    createSizeButton: function(value, optionName) {
      const wrapper = document.createElement('div');
      wrapper.className = 'phe-size-option';
      
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = optionName;
      input.value = value;
      input.id = 'phe-option-' + value.replace(/\s+/g, '-');
      if (this.selectedOptions[optionName] === value) {
        input.checked = true;
      }
      
      const label = document.createElement('label');
      label.htmlFor = input.id;
      label.className = 'phe-size-label';
      label.textContent = value;
      
      input.addEventListener('change', function() {
        if (input.checked) {
          this.selectOption(optionName, value);
        }
      }.bind(this));
      
      wrapper.appendChild(input);
      wrapper.appendChild(label);
      
      return wrapper;
    },

    selectOption: function(optionName, value) {
      this.selectedOptions[optionName] = value;
      this.updateVariant();
      this.render(); // Re-render to update active states
    },

    updateVariant: function() {
      // Find matching variant
      // Handle single variant products (no options)
      let variant = null;
      
      if (!this.currentProduct.options || this.currentProduct.options.length === 0 || 
          (this.currentProduct.options.length === 1 && this.currentProduct.options[0].name === 'Title')) {
        // Single variant product - use first variant
        variant = this.currentProduct.variants && this.currentProduct.variants.length > 0 
          ? this.currentProduct.variants[0] 
          : null;
      } else {
        // Multi-variant product - find matching variant
        variant = this.currentProduct.variants.find(function(v) {
          return (v.option1 === this.selectedOptions[this.currentProduct.options[0]?.name] || !this.currentProduct.options[0]) &&
       (v.option2 === this.selectedOptions[this.currentProduct.options[1]?.name] || !this.currentProduct.options[1]) &&
       (v.option3 === this.selectedOptions[this.currentProduct.options[2]?.name] || !this.currentProduct.options[2]);
        }.bind(this));
      }

      this.currentVariant = variant;

      // Update hidden input
      const variantInput = this.form.querySelector('[data-variant-id]');
      const submitBtn = this.form.querySelector('.product-form__submit');

      if (variant && submitBtn) {
        variantInput.value = variant.id;
        
        // Always show button, but disable if unavailable
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.removeAttribute('hidden');
          submitBtn.style.display = 'block';
          submitBtn.style.visibility = 'visible';
          
          // Update button text to "Add to Bag"
          const buttonSpan = submitBtn.querySelector('span');
          if (buttonSpan) {
            buttonSpan.textContent = 'Add to Bag';
          }
        } else {
          // Show button but keep it disabled when unavailable
          submitBtn.disabled = true;
          submitBtn.removeAttribute('hidden');
          submitBtn.style.display = 'block';
          submitBtn.style.visibility = 'visible';
          
          // Update button text to "Sold Out"
          const buttonSpan = submitBtn.querySelector('span');
          if (buttonSpan) {
            buttonSpan.textContent = 'Sold Out';
          }
        }
        
        // Update price if variant has different price
        if (variant.price) {
          this.panel.querySelector('[data-product-price]').textContent = variant.price;
        }

        // Update carousel if variant has featured image
        if (variant.featured_image) {
          if (this.swiper && this.swiper.slides.length > 0) {
            // Find image in carousel or add it
            const firstSlide = this.swiper.slides[0].querySelector('img');
            if (firstSlide) {
              firstSlide.src = variant.featured_image;
            }
          }
        }
      } else {
        // No variant found - still show button but disabled
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.removeAttribute('hidden');
          submitBtn.style.display = 'block';
          submitBtn.style.visibility = 'visible';
        }
      }
    },

    loadProductIntoQuickAdd: function(productUrl) {
      const url = productUrl.split('?')[0] + '.json';
      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (!data || !data.product) return;
          const mapped = this.mapProductJsonToQuickAdd(data.product);

          // Preserve siblings swatch data so we can still render swatches
          mapped.metafields = this.currentProduct && this.currentProduct.metafields ? this.currentProduct.metafields : null;

          // Reset selections to first values of loaded product
          this.currentProduct = mapped;
          this.selectedOptions = {};
          if (mapped.options && mapped.options.length > 0) {
            mapped.options.forEach(function(option) {
              if (option.values && option.values.length > 0) {
                this.selectedOptions[option.name] = option.values[0];
              }
            }.bind(this));
          }

          this.render();
          this.updateVariant();
        }.bind(this))
        .catch(function(err) { console.error('Quick Add swatch load error:', err); });
    },

    mapProductJsonToQuickAdd: function(p) {
      // Images
      var images = (p.images || []).map(function(img) {
        return { url: img.src, alt: p.title };
      });

      // Variants
      var variants = (p.variants || []).map(function(v) {
        return {
          id: String(v.id),
          title: v.title,
          option1: v.option1 || null,
          option2: v.option2 || null,
          option3: v.option3 || null,
          available: !!v.available,
          price: window.PheQuickAdd.centsToMoney(v.price),
          featured_image: v.featured_image ? v.featured_image.src : null
        };
      });

      // Options (derive from variants). Handle both ["Color","Size"] and [{name:"Color"}].
      var options = [];
      var optionNames = [];
      if (Array.isArray(p.options) && p.options.length) {
        if (typeof p.options[0] === 'string') {
          optionNames = p.options;
        } else if (p.options[0] && typeof p.options[0].name === 'string') {
          optionNames = p.options.map(function(o){ return o.name; });
        }
      }
      optionNames.forEach(function(name, idx) {
        var pos = idx + 1; // 1..3
        var key = 'option' + pos;
        var valuesSet = {};
        (p.variants || []).forEach(function(v) {
          var val = v[key];
          if (val) valuesSet[val] = true;
        });
        options.push({ name: name, position: pos, values: Object.keys(valuesSet) });
      });

      // Use min variant price for header
      var minCents = null;
      (p.variants || []).forEach(function(v) {
        var c = Number(v.price || 0);
        if (minCents === null || c < minCents) minCents = c;
      });

      return {
        id: String(p.id),
        title: p.title,
        url: '/products/' + p.handle,
        price: minCents != null ? window.PheQuickAdd.centsToMoney(minCents) : '',
        images: images,
        options: options,
        variants: variants
      };
    },

    centsToMoney: function(raw) {
      // Normalize: input may be cents (9000) or dollars (90 or "90.00") depending on endpoint
      var cents;
      if (typeof raw === 'string') {
        if (raw.indexOf('.') !== -1) {
          cents = Math.round(parseFloat(raw) * 100);
        } else {
          cents = parseInt(raw, 10);
        }
      } else if (typeof raw === 'number') {
        cents = raw >= 1000 ? Math.round(raw) : Math.round(raw * 100);
      } else {
        cents = 0;
      }
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        try { return Shopify.formatMoney(cents); } catch (e) {}
      }
      return '$' + (cents / 100).toFixed(2);
    },

    close: function() {
      this.backdrop.classList.remove('active');
      this.panel.classList.remove('active');
      
      // Remove third-party app detection classes from body
      // Only remove template-product if we added it (not if it was already there)
      document.body.classList.remove('quick-add-active');
      if (this.wasProductPage === false) {
        document.body.classList.remove('template-product');
        document.body.removeAttribute('data-template');
      }
      
      // Remove panel-level classes and attributes
      this.panel.classList.remove('template-product-context');
      this.panel.removeAttribute('data-product-id');
      this.panel.removeAttribute('data-product-handle');
      this.panel.removeAttribute('data-product-title');
      
      // Destroy swiper immediately
      if (this.swiper) {
        try {
          this.swiper.destroy(true, true); // destroy with cleanup
        } catch (e) {
          console.warn('Swiper destroy error:', e);
        }
        this.swiper = null;
      }
      
      // Reset form state
      if (this.form) {
        this.form.reset();
        const variantInput = this.form.querySelector('[data-variant-id]');
        if (variantInput) variantInput.value = '';
        const submitBtn = this.form.querySelector('.product-form__submit');
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.removeAttribute('hidden');
          submitBtn.style.display = 'block';
        }
      }
      
      // Clear current product and variant
      this.currentProduct = null;
      this.currentVariant = null;
      this.selectedOptions = {};
    },

    initializeThirdPartyApps: function() {
      if (!this.currentProduct) return;
      
      // Klaviyo Back-in-Stock detection
      if (window._learnq && typeof window._learnq.push === 'function') {
        // Track product view for Klaviyo
        window._learnq.push(['track', 'Viewed Product', {
          ProductID: this.currentProduct.id,
          ProductName: this.currentProduct.title,
          ProductURL: this.currentProduct.url,
          ProductHandle: this.currentProduct.url.replace('/products/', '').replace(/\/$/, '')
        }]);
        
        // Trigger Klaviyo to re-scan for BIS buttons
        setTimeout(() => {
          if (window._learnq && window._learnq.push) {
            window._learnq.push(['track', 'Quick Add Opened', {
              ProductID: this.currentProduct.id,
              ProductName: this.currentProduct.title
            }]);
          }
        }, 100);
      }
      
      // Dispatch custom event for other third-party apps
      const event = new CustomEvent('quickAddOpened', {
        detail: {
          product: this.currentProduct,
          variant: this.currentVariant,
          panel: this.panel
        }
      });
      document.dispatchEvent(event);
      
      // Trigger any app-specific initialization
      if (window.Shopify && window.Shopify.analytics) {
        // Shopify analytics tracking
        try {
          window.Shopify.analytics.publish('productView', {
            productId: this.currentProduct.id,
            productTitle: this.currentProduct.title,
            productUrl: this.currentProduct.url
          });
        } catch (e) {
          // Ignore errors
        }
      }
    },

  };

  // Auto-initialize on DOMContentLoaded
  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        try {
          window.PheQuickAdd.init();
        } catch (error) {
          console.error('PheQuickAdd init error:', error);
        }
      });
    } else {
      window.PheQuickAdd.init();
    }
  } catch (error) {
    console.error('PheQuickAdd setup error:', error);
  }
})();
